import type { ObjectRoomId } from '@previo/codebooks'
import { ObjectKind } from '~/store/property/objectKinds/model/ObjectKind'

export class ObjectRoom {
  constructor(
    public readonly objectRoomId: ObjectRoomId,
    public readonly name: string,
    public readonly objectKind: ObjectKind,
  ) {}

  get withCapacity(): string {
    if (!this.objectKind.hasCapacity()) {
      return this.name
    }

    return `(${this.objectKind.capacityString()}) - ${this.name}`
  }
}
